import React from 'react';

export const DocusignIconBorderless = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.5227 11.4761V15.5511C11.5227 15.7652 11.3493 15.9381 11.1345 15.9381H0.388221C0.173459 15.9381 0 15.7652 0 15.5511V4.84901C0 4.63492 0.173459 4.46204 0.388221 4.46204H4.46867V11.0892C4.46867 11.3032 4.64213 11.4761 4.85689 11.4761H11.5227Z"
			fill="#4C00FF"
		/>
		<path
			d="M15.9998 5.72983C15.9998 9.15447 13.9926 11.4678 11.5228 11.476V7.16226C11.5228 7.03879 11.4732 6.91523 11.3824 6.83297L9.13569 4.59374C9.04482 4.50321 8.92921 4.4538 8.80524 4.4538H4.47705V0.386951C4.47705 0.172901 4.65051 2.19893e-05 4.86526 2.19893e-05H10.9199C13.7943 -0.00821231 15.9998 2.29687 15.9998 5.72983Z"
			fill="#FF5252"
		/>
		<path
			d="M11.3824 6.82451C11.4732 6.91513 11.5228 7.03033 11.5228 7.15388V11.4677H4.86526C4.65051 11.4677 4.47705 11.2948 4.47705 11.0807V4.45361H8.80524C8.92921 4.45361 9.0531 4.50302 9.13569 4.59355L11.3824 6.82451Z"
			fill="black"
		/>
	</svg>
);
